import React, { Component } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Layout } from './components/Layout';
import './custom.css';
import Home from "./components/Home";
import { Login } from "./components/Login";
import { SiteExcel } from "./components/SiteExcel";
import { SiteScanApply } from "./components/SiteScanApply";
import { SiteResultResearch } from "./components/SiteResultResearch";
import { SiteScanHistoryData } from "./components/SiteScanHistoryData";
import { SiteStatistical } from "./components/SiteStatistical";
import { PageCiaInfo } from "./components/PageCiaInfo";
import { UserTypeSet } from "./components/UserTypeSet";
import Usersettings from "./components/Usersettingsmenu/Usersettings";
import { DomainSet } from './components/DomainSet';
import { FromChangePassword as ChangePassword } from './components/FromChangePassword';
import { FormModifyinformation } from './components/FormModifyinformation';
import { UserlocalNetSet } from './components/UserlocalNetSet';
import LocalNetComparisonData from './components/Context/LocalNetComparisonData';
import UrlReportZipPasswordData from './components/Context/UrlReportZipPassword';
import TrackBackground from './components/TrackingHook/TrackBackground';
import WAFBackground from './components/TrackingHook/WAFBackground';
import ViewTrackingDetail from './components/TrackingHook/ViewTrackingDetail';
import ViewWAFDetail from './components/TrackingHook/ViewWAFDetail';
import FetchTrackingDetail from './components/FetchTrackingDetail';
import FetchWAFDetail from './components/FetchWAFDetail';
import BUGBackground from './components/TrackingHook/BUGBackground';
import HistoryTrackBackground from './components/TrackingHook/HistoryTrackBackground';
import HCLAppScanBackground from './components/HCLAppScanBackground';
import TenableBackground from './components/TenableHooK/TenableBackground';
import TenableResultResearch from './components/TenableHooK/TenableResultResearch';
import TenableHistorypage from './components/TenableHooK/TenableHistoryData';
import TenableTrackBackground from './components/TenableHooK/Tenable_Track_Background';
import HistoryTenableTrackBackground from './components/TenableHooK/History_Track_Background';
import TenBUGBackground from './components/TenableHooK/TenBUGBackground';
import HistoryTenTrackingDetail from './components/TenableHooK/HistoryTenTrackingDetail';
import FetchTenTrackingDetail from './components/TenableHooK/FetchTenTrackingDetail';
import ViewTenTrackingDetail from './components/TenableHooK/ViewTenTrackingDetail';

import { Counter } from "./components/Counter";

export default class App extends Component {
  static displayName = App.name;

  render() {
    return (
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />

          <Route path="/cia-scanner">
            <Route path="cia-site-manage" element={<SiteExcel />} />
            <Route path="cia-apply" element={<SiteScanApply />} />
            <Route path="cia-statistical" element={<SiteStatistical />} />
            <Route path="cia-user-type-set" element={<UserTypeSet />} />
            <Route path="cia-user-set" element={<Usersettings />} />
            <Route path="cia-domain-set" element={<DomainSet />} />
            <Route path="cia-user-local-Net-set" element={<UserlocalNetSet />} />
            <Route path="Site-Scan-History-Data" element={<SiteScanHistoryData />} />
            <Route path="cia-local-net-Comparison-Data" element={<LocalNetComparisonData />} />
            <Route path="cia-Url-Report-Zip-Password" element={<UrlReportZipPasswordData />} />
          </Route>

          <Route path="/TrackBackground" element={<TrackBackground />} />
          <Route path="/WAFBackground" element={<WAFBackground />} />
          <Route path="/BUGBackground" element={<BUGBackground />} />
          <Route path="/TrackBackground/HistoryTrackBackground" element={<HistoryTrackBackground />} />

          <Route path="/HostBackground" element={<TenableTrackBackground />} />
          <Route path="/HostBugBackground" element={<TenBUGBackground />} />
          <Route path="/HistoryHostBackground" element={<HistoryTenableTrackBackground />} />

          <Route path="/webScanApplication" element={<HCLAppScanBackground />} />
          <Route path="/hostAndWebsiteScan" element={<TenableBackground />} />
          <Route path="/websiteScanResults" element={<SiteResultResearch />} />
          <Route path="/hostScanResults" element={<TenableResultResearch />} />
          <Route path="/hostHistorypage" element={<TenableHistorypage />} />

          <Route path="/FetchTrackingDetail" element={<FetchTrackingDetail />} />
          <Route path="/FetchhostTrackingDetail" element={<FetchTenTrackingDetail />} />
          <Route path="/ViewhostTrackingDetail" element={<ViewTenTrackingDetail />} />
          <Route path="/FetchWAFDetail" element={<FetchWAFDetail />} />
          <Route path="/ViewTrackingDetail" element={<ViewTrackingDetail />} />
          <Route path="/ViewWAFDetail" element={<ViewWAFDetail />} />
          <Route path="/HistoryTrackingDetail" element={<HistoryTenTrackingDetail />} />

          <Route path="/manual" element={<Counter />} />
          <Route path="/cia-info" element={<PageCiaInfo />} />
          <Route path="/login" element={<Login />} />
          <Route path="/FromChangePassword" element={<ChangePassword />} />
          <Route path="/FormModifyinformation" element={<FormModifyinformation />} />

          <Route
            path="*"
            element={
              <main style={{ padding: '1rem' }}>
                <p>There's nothing here!</p>
              </main>
            }
          />
        </Routes>
      </Layout>
    );
  }
}
